import React from "react";
import { Faq } from "component/common/FraudDetails";
import RightArrowIcon from "assets/images/menuicons/right-arrow.svg";
import { ExtensionCard } from "../MotorInsuranceComponent";
import "./style.scss";
import { MotorProductCard } from "../MotorInsuranceComponent";
import { ProductAndServicesCard } from "component/common/ProductAndServicesCard";
import HeaderStickyMenu from "component/common/MobileReuseable/HeaderStickyMenu";
import { CommonTableMobile } from "component/common/CommonTable/CommonTableMobile";
import { ProductServicCard } from "../MotorInsuranceComponent/ProductService/ProductServiceCard";
import { InsuranceMobileComponent } from "../MotorInsuranceComponent/InsuranceMobile/InsuranceMobile";
import { ReactComponent as SettingIcon } from "assets/svg/settingIcon.svg";
import { ReactComponent as DownloadPolicy } from "assets/svg/download_policy.svg";
import { ReactComponent as ReviewPolicy } from "assets/svg/review_policy.svg";
import { ProductList, externalLinks } from "helpers/constant";

import MobileSocialMedia from "component/common/MobileSocialMedia";
import { getI18n, useTranslation } from "react-i18next";
import mobileTickIcon from "../../../assets/svg/mobileTickIcon.svg";
import mobileCrossRed from "../../../assets/svg/mobileCrossRed.svg";
import mobilePlusOrange from "../../../assets/svg/plusMobile.svg";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

export const MotorInsurancepageMobile = () => {
    const { i18n, t } = useTranslation(); const userID = useSelector(
        (state) => state?.loginDetailsReducer?.loginResponse?.user_info?.userID
    );
    const history = useHistory();
    const headerData = {
        header1Title: t('motorPageData.plansData.coversAndBenefits'),
        header2Title: t('motorPageData.plansData.alshamal'),
        header3Title: t('motorPageData.plansData.sanad'),
        header4Title: t('motorPageData.plansData.sanadPlus'),
        headerComprehensive: t('motorPageData.plansData.comprehensive'),
        bestSeller: t('motorPageData.plansData.bestSeller'),
    };

    const tableData = [
        {
            title: t('motorPageData.plansData.planKey1'),
            item1: mobileTickIcon,
            item2: mobileCrossRed,
            item3: '',
            text2: '',
            text3: t('motorPageData.plansData.upto10k')
        },
        {
            title: t('motorPageData.plansData.planKey2'),
            item1: mobileTickIcon,
            item2: mobileTickIcon,
            item3: mobileTickIcon
        },
        {
            title: t('motorPageData.plansData.planKey3'),
            item1: mobileTickIcon,
            item2: mobileCrossRed,
            item3: mobileCrossRed
        },
        {
            title: t('motorPageData.plansData.planKey4'),
            item1: mobileTickIcon,
            item2: mobileCrossRed,
            item3: mobileCrossRed
        },
        {
            title: t('motorPageData.plansData.planKey5'),
            item1: mobileTickIcon,
            item2: mobileCrossRed,
            item3: mobileCrossRed
        },
        {
            title: t('motorPageData.plansData.planKey6'),
            item1: mobileTickIcon,
            item2: mobileTickIcon,
            item3: mobileTickIcon
        },
        {
            title: t('motorPageData.plansData.planKey7'),
            item1: mobileTickIcon,
            item2: mobileTickIcon,
            item3: mobileTickIcon
        },
        {
            title: t('motorPageData.plansData.planKey8'),
            item1: mobileTickIcon,
            item2: mobileTickIcon,
            item3: mobileTickIcon
        },
        {
            title: t('motorPageData.plansData.planKey9'),
            item1: mobileTickIcon,
            item2: mobilePlusOrange,
            item3: mobilePlusOrange
        },
        {
            title: t('motorPageData.plansData.planKey10'),
            item1: mobileTickIcon,
            item2: mobilePlusOrange,
            item3: mobilePlusOrange
        },
        {
            title: t('motorPageData.plansData.planKey11'),
            item1: mobileTickIcon,
            item2: mobilePlusOrange,
            item3: mobilePlusOrange
        },
        {
            title: t('motorPageData.plansData.planKey12'),
            item1: mobileTickIcon,
            item2: mobilePlusOrange,
            item3: mobilePlusOrange
        },
        {
            title: t('motorPageData.plansData.planKey13'),
            item1: mobileTickIcon,
            item2: mobilePlusOrange,
            item3: mobilePlusOrange
        },
        {
            title: t('motorPageData.plansData.planKey14'),
            item1: mobileTickIcon,
            item2: mobileCrossRed,
            item3: mobileCrossRed
        },
    ];

    const headerMechData = {
        header1Title: t('motorPageData.mechanicalBreak.headerText.firstTitle'),
        header2Title: t('motorPageData.mechanicalBreak.headerText.gold'),
        header3Title: t('motorPageData.mechanicalBreak.headerText.silver'),
        header4Title: t('motorPageData.mechanicalBreak.headerText.bronze'),
        headerComprehensive: t('motorPageData.plansData.comprehensive'),
        bestSeller: t('motorPageData.plansData.bestSeller'),
    };

    const tableMechData = [
        {
            title: t('motorPageData.mechanicalBreak.breakService1'),
            text1: t('motorPageData.mechanicalBreak.price20k'),
            text2: t('motorPageData.mechanicalBreak.price20k'),
            text3: t('motorPageData.mechanicalBreak.price20k')
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService2'),
            text1: t('motorPageData.mechanicalBreak.price10k'),
            text2: t('motorPageData.mechanicalBreak.price10k'),
            text3: t('motorPageData.mechanicalBreak.price10k')
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService3'),
            text1: t('motorPageData.mechanicalBreak.price10k'),
            text2: t('motorPageData.mechanicalBreak.price10k'),
            text3: t('motorPageData.mechanicalBreak.price10k')
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService4'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price5k'),
            text2: t('motorPageData.mechanicalBreak.price5k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService5'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price5k'),
            text2: t('motorPageData.mechanicalBreak.price5k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService6'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
            text2: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService7'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
            text2: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService8'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
            text2: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService9'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
            text2: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService10'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
            text2: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService11'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
            text2: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService12'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
            text2: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService13'),
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
            text2: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService14'),
            item2: mobileCrossRed,
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService15'),
            item2: mobileCrossRed,
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService16'),
            item2: mobileCrossRed,
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService17'),
            item2: mobileCrossRed,
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService18'),
            item2: mobileCrossRed,
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService19'),
            item2: mobileCrossRed,
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
        },
        {
            title: t('motorPageData.mechanicalBreak.breakService20'),
            item2: mobileCrossRed,
            item3: mobileCrossRed,
            text1: t('motorPageData.mechanicalBreak.price4k'),
        },
    ];
    const faqCategoryDataMotor = [
        {
            id: 0,
            question: t('motorPageData.motorPageFaqs.question1'),
            answer: t('motorPageData.motorPageFaqs.answer1'),
        },
        {
            id: 1,
            question: t('motorPageData.motorPageFaqs.question2'),
            answer: t('motorPageData.motorPageFaqs.answer2')
        },
        {
            id: 2,
            question: t('motorPageData.motorPageFaqs.question3'),
            answer: t('motorPageData.motorPageFaqs.answer3')
        },
        {
            id: 3,
            question: t('motorPageData.motorPageFaqs.question4'),
            answer: t('motorPageData.motorPageFaqs.answer4')
        },
        {
            id: 4,
            question: t('motorPageData.motorPageFaqs.question5'),
            answer: t('motorPageData.motorPageFaqs.answer5'),
        },
        {
            id: 5,
            question: t('motorPageData.motorPageFaqs.question6'),
            answer: t('motorPageData.motorPageFaqs.answer6')
        },
        {
            id: 6,
            question: t('motorPageData.motorPageFaqs.question7'),
            answer: t('motorPageData.motorPageFaqs.answer7')
        },
    ];

    const handleClicks = (val) => {
        if (val === 1) {
            let link = val === 1?"/dashboard/policy-detail":externalLinks.Renewal + "renewal?lang=en";
            if(userID){
                history.push(link)
           } else {
            history.push('/login/')        }
        } 
         else {
            window.location.href = `https://tawuniya.com/products/renewal?lang=${i18n.language}`;
        }
    }

    const currentLanguage = getI18n().language;
    let buyNowLink = currentLanguage === "ar" ? "https://www.tawuniya.com/ar/individuals" : "https://www.tawuniya.com/en/individuals";
    const trackEvent = (tabClicked) => {
		window.lmSMTObj.track(tabClicked);
	}
    return (
        <React.Fragment>
            <HeaderStickyMenu
                title={t('motor-insurence.Motor-Insurance')}
                buyNowLink={buyNowLink}
                fromMotor={true}
                quoteFor={ProductList.MOTOR}
                buttonTitle={t('motorPageData.buyNow')}
                isVisibleSubHeader={true} />
            <div className="MotorInsuranceMainContainer motor-insurence-container-mobile">
                {/*<AppBanner />*/}
                {/* Mobile page */}
                {/* <Insurance /> */}
                <InsuranceMobileComponent />


                <div className="manage-policy">
                    <div className="policy-header">
                        <div className="header-icon-wrapper">
                            <SettingIcon className="icon-com" />
                        </div>
                        <div className="title-sub-title">
                            <h3 className="title">{t('motorPageData.managePolicy.title')}</h3>
                            <p className="sub-title">{t('MotorIns.AddMore')}</p>
                        </div>
                    </div>
                    <div className="policy-body">
                        <div className="policy-item c-pointer">
                            <div className="policy-icon" onClick={() => {handleClicks(1);trackEvent(t('motorPageData.managePolicy.downloadPolicy')+"Clicked")}}>
                                <DownloadPolicy className="icon-policy" />
                            </div>
                            <p className="download-policy-text">{t('motorPageData.managePolicy.downloadPolicy')}</p>
                        </div>
                        <span className="middle-line"></span>
                        <div className="policy-item c-pointer" onClick={() => {handleClicks(2);trackEvent(t('motorPageData.managePolicy.renewPolicy')+"Clicked")}}>
                            <div className="policy-icon">
                                <ReviewPolicy className="icon-policy" />
                            </div>
                            <p className="download-policy-text">{t('motorPageData.managePolicy.renewPolicy')}</p>
                        </div>
                    </div>
                </div>
                <MotorProductCard />
                <div className="motor-table-wrapper">
                    <h3 className="heading">{t('motorPageData.plansData.title')}</h3>
                    <CommonTableMobile
                        headerData={headerData}
                        tableData={tableData}
                    />
                </div>
                <div className="mobile-wrapper-extentionCard">
                    <ExtensionCard />
                </div>
                <div className="row">
                    <div className="col-12 pt-5">
                        <p className="breakdownHeading fw-800 m-0">
                            {t('motorPageData.mechanicalBreak.title')}
                        </p>
                        {
                            window.innerWidth > 950 &&
                            <p className="breakingPara fw-400 pb-2">
                                {t('motorPageData.mechanicalBreak.desc')}
                            </p>
                        }
                        <CommonTableMobile
                            headerData={headerMechData}
                            tableData={tableMechData}
                        />
                        <ul className="policy-text-wrapper">
                            <li className="policy-item">{t('motorPageData.mechanicalBreak.shortPara2')}</li>
                            <li className="policy-item">{t('motorPageData.mechanicalBreak.shortPara1')}</li>
                        </ul>
                    </div>
                </div>

                <div className="mobile-wrapper-extentionCard">
                    <ProductServicCard title={t('motorPageData.insuranceDeclarationSection.title')} />
                    <div className="view-all-wrapper">
                        <div className="view-all">
                            {/*<div className="view-all-questions">*/}
                            {/*    <span className="view-all-text">View All questions </span>*/}
                            {/*    <img className="view-all-image" src={RightArrowIcon} alt="view all" />*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>

                <div className="motor-faq-container">
                    <Faq faqData={faqCategoryDataMotor} viewAll={false} />
                </div>
                {/* <TwuniyaAppAdvert /> */}
                <div className="mt-4">
                    <ProductAndServicesCard title={'Products and Services'} />
                </div>
                {/*<BottomSectionView/>*/}
                <MobileSocialMedia />
            </div>
        </React.Fragment>
    );
};
